import { ICommodityInventoryReportInitialState } from '../interfaces/CommodityInventoryReportInterface';

export const COMMODITY_INVENTORY_REPORT_INITIAL_STATE: ICommodityInventoryReportInitialState =
    {
        commodityUsageReport: [],
        dailyCommodityReport: [],
        loading: true,
    };
